import React, {} from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { MdEdit as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";
// Actions
import * as mainActions from "../../../redux/actions/main";

const ButtonEdit = ({ 
  primaryValue, 
  primaryName,
  config,
  page,
  itemNameSingular,
  onEditAddStringAtEndOfPath = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => !!state.mainReducer.breadscrum[currentPage] ? state.mainReducer.breadscrum[currentPage] : []);

  let caption = "Editar"
  let onClick = () => { 
    const pathKey = 'edit';
    let path = `${page}/${pathKey}`;
    if (!!primaryValue){
      path += `/${primaryValue}`;
    }
    if (!!onEditAddStringAtEndOfPath) {
      path += onEditAddStringAtEndOfPath;
    }
    // Add item to breadscrum
    dispatch(mainActions.setBreadscrum(currentPage, [...breadscrum, { path, pathKey, primaryValue, primaryName, itemNameSingular, }]));
    // Goto
    navigate(`/${path}`);
  };
  let width = "120px";
  let marginLeft = "0px";
  let disabled = false;
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
    if (config.disabled) disabled = true
  }
  return (
    <CommonButton
      onClick={onClick}
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "8px", // Add spacing between icon and text
      }}
      disabled={disabled}
    >
      <Ico size={18} />
      <span>{caption}</span>
    </CommonButton>
  );
};

export default ButtonEdit;
